import React from 'react'
import { Props } from './types'
import styles from './StatisticElement.module.scss'

const StatisticElementComponent = (props: Props) => {
  const {
    icon: Icon,
    label,
    value,
    // preset = 'primary'
  } = props

  return (
    <div className={styles.statElement}>
      <Icon height={30} />
      <div className={styles.infoContainer}>
        <h4>{label}</h4>
        <p>{value}</p>
      </div>
    </div>
  )
}

const StatisticElement = StatisticElementComponent
export { StatisticElement }
